import { render, staticRenderFns, recyclableRender, components } from "./look-evaluate.vue?vue&type=template&id=681d2dcc&"
var renderjs
import script from "./look-evaluate.vue?vue&type=script&lang=js&"
export * from "./look-evaluate.vue?vue&type=script&lang=js&"
import style0 from "./look-evaluate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/product/detail/look-evaluate/look-evaluate.vue"
export default component.exports